import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    footer: {
        backgroundColor: '#f1f1f1',
        padding: '3px 20px',
        position: 'fixed',
        bottom: 0,
        width: '100%',
        textAlign: 'center',
        borderTop: '1px solid #e0e0e0',
    },
});

const Footer: React.FC = () => {
    const classes = useStyles();
    return (
        <Box className={classes.footer}>
            <Typography variant="body2" color="textSecondary">
                © {new Date().getFullYear()} <Link href="https://prishops.nl" target="_blank" rel="noopener noreferrer">PRISHOPS</Link>. All rights reserved.
            </Typography>
        </Box>
    );
};

export default Footer;